import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";


const acModuleEntry: TestModuleDefinition = {
    key: 'ac',
    label: 'Commission (ac)',
    components: [
    ]
}

export const AC_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: acModuleEntry, multi: true}
];